<template>
  <v-form ref="form" @submit.prevent="saveForm">
    <div class="form-container">
      <LocomotiveFieldFactory
        v-model="locomotives"
        label="Numery lokomotyw"
        :companyId="this.serviceCompany.id"
        :icon="null"
        multiple
        :rules="[required]"
      />
    </div>

    <DialogSaveButton type="submit" style="padding-left: 0 !important; padding-right: 0 !important" />
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import LocomotiveFieldFactory from '@/component/Field/Locomotive/locomotive-field-factory';
import DialogSaveButton from '@/component/Dialog/dialog-save-button';
import { SERVICE_TYPE_DICT } from '@/core/dict/service-type-dict';
import { cloneDeep } from 'lodash';

export default {
  name: 'LocomotiveWashing',
  components: {
    LocomotiveFieldFactory,
    DialogSaveButton,
  },
  props: {
    entity: Object,
    company: Object,
    isAddMode: Boolean,
  },
  data() {
    return {
      locomotives: [],
    };
  },
  created() {
    if (!this.isAddMode && this.entity) {
      this.locomotives = cloneDeep(this.entity.locomotives);
    } else if (this.isLocomotiveWashingAdded) {
      const service = this.$store.getters['service/services'].find(
        ({ serviceType }) => serviceType === SERVICE_TYPE_DICT.LOCOMOTIVE_WASHING
      );
      this.locomotives = service.locomotives;
    }
  },
  computed: {
    ...mapGetters('service', ['isLocomotiveWashingAdded']),
    serviceCompany() {
      return this.company || this.$store.getters['service/serviceCompany'];
    },
  },
  methods: {
    required(v) {
      return v.length > 0 || 'Wybierz przynajmniej jedną lokomotywę';
    },
    saveForm() {
      if (this.$refs.form.validate()) {
        const payload = {
          serviceType: SERVICE_TYPE_DICT.LOCOMOTIVE_WASHING,
          locomotives: this.locomotives,
        };

        if (this.isAddMode) {
          this.$emit('addServiceItem', payload);
        } else if (this.entity) {
          this.$emit('editExistingServiceItem', payload);
        } else if (this.isLocomotiveWashingAdded) {
          this.$store.dispatch('service/updateService', payload);
        } else {
          this.$store.dispatch('service/addService', payload);
        }

        this.$emit('submit');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
</style>
